import {
  IOmnisearchClient,
  IOmnisearchOpportunity,
  IOmnisearchProfile,
  IOmnisearchSolicitationExpert,
  OmnisearchEntity,
} from '../models/omnisearch.models';

export const opportunityData: IOmnisearchOpportunity = {
  entity: OmnisearchEntity.opportunities,
  id: 'opp-id',
  publicDisplayId: 'pub-id',
  name: 'Test Opportunity',
  clientId: 'client-id',
  opportunityAssigneeIds: [],
  omnisearchHidden: false,
  onHold: false,
};

export const profileData: IOmnisearchProfile = {
  entity: OmnisearchEntity.profiles,
  id: 'expert-id',
  name: 'Test Expert',
  nameHighlight: 'Test Expert',
  matchedEmail: 'testexpert@email.com',
  matchedEmailHighlight: '<em>testexpert@email.com</em>',
  matchedPhoneNumber: '123-456-7890',
  matchedPhoneNumberHighlight: '<em>123-456-7890</em>',
  lastEvent: '',
  relevance: 1,
  geographicTarget: 'GB',
};

export const solicitationExpertData: IOmnisearchSolicitationExpert = {
  entity: OmnisearchEntity.solicitationExperts,
  id: 'expert-id',
  name: 'Test Expert',
  emailAddress: 'testexpert@email.com',
  allEmails: [],
  oppId: 'opp-id',
  oppName: 'opp-name',
  clientId: 'client-id',
  profileType: 'profile',
  geographicTarget: 'GB',
};
export const clientData: IOmnisearchClient = {
  entity: OmnisearchEntity.clients,
  id: 'client-id',
  name: 'Test Client',
};
